import React, { useContext, useState, useEffect, useRef } from "react";
import { Button, ListGroup, Row, Col, Form, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import BasketStorage from "../../Basket/Component/BasketStorage";
import _ from "lodash";
import { IconArrowRight } from "../../../../assets/icons";
import ContextApp from "../../../../core//contexts/context.app";
import { BasketHelper } from "../../../../core/utils/BasketHelper";

function ModalSelectName({
  modalSelectNameInfo, setModalSelectNameInfo
}) {

  const ctx = useContext(ContextApp);


  const textInput = useRef(null);
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      // fullName: selectedName,
    },
  });

  const [listBasketPerson, setListBasketPerson] = useState();
  const handleClose = () => {
    setModalSelectNameInfo({ ...modalSelectNameInfo, show: false });
  };
  useEffect(() => {
    if (modalSelectNameInfo.show) {
      var listBP = BasketStorage.getBasketPerson();
      setListBasketPerson(_.reject(listBP, { id: -1 }));
    }
  }, [modalSelectNameInfo]);

  const submitNewName = async (data) => {
    const personLists = [];
    personLists.push({ personFullName: data.fullName });
    // updateSelectedName(data.fullName);
    const basketPerson = await BasketHelper.addBasketPersonList(ctx, personLists);

    const newPerson = _.find(basketPerson, { basketPersonPersonFullName: data.fullName })
    const basket = BasketHelper.changeBasketItemPerson(ctx,modalSelectNameInfo.basketPersonPerson,newPerson);
    
  };
  const selectName = async (data) => {
  };
  return (
    <Modal show={modalSelectNameInfo.show} scrollable onHide={handleClose}>
      <form id="form" onSubmit={handleSubmit(submitNewName)}>
        <Modal.Header onClick={handleClose}>
          <IconArrowRight fillColor="#000" />
          ویرایش نام و خانوادگی
        </Modal.Header>

        <Modal.Body>
          <div className="mt-3">
            <div>
              <label className="mb-2">نام و نام خانوادگی را وارد نمایید </label>
              <Controller
                name="fullName"
                control={control}
                render={({ field: { onChange, value } }) => (
                  <div>
                    <div className="d-flex">
                      <Form.Control
                        type="text"
                        autoFocus={true}
                        name="fullName"
                        className="rounded-end-0"
                        autoComplete="off"
                        placeholder="نام و نام خانوادگی"
                        value={value || ""}
                        onChange={onChange}
                        ref={textInput}
                      />
                      <button
                        className="btn btn-warning fs-085 rounded-start-0"
                        style={{ width: "100px" }}
                        type="submit"
                      >
                        ثبت
                      </button>
                    </div>
                    <div>
                      {!_.isEmpty(listBasketPerson) && (
                        <label className="mr-2 mt-2" style={{ fontSize: 12.8 }}>
                          یا از لیست زیر انتخاب نمایید{" "}
                        </label>
                      )}
                      <ListGroup
                        as="ul"
                        style={{
                          width: "100%",
                          overflowY: "auto",
                          fontSize: 12.8,
                        }}
                        className="px-2 text-center mb-3"
                      >
                        {listBasketPerson &&
                          listBasketPerson.map((person, key) => {
                            return (
                              <div key={key}>
                                <ListGroup.Item
                                  key={key}
                                  style={{
                                    border: "none",
                                    backgroundColor: "#f9f9f9",
                                    boxShadow: "1px 2px 9px #dee2e6",
                                    cursor: "pointer",
                                  }}
                                  className="my-2 rounded-3"
                                  type="submit"
                                  as="li"
                                >
                                  <Row
                                    className="px-2"
                                    onClick={() => {
                                      selectName({
                                        fullName: person.personFullName,
                                      });
                                    }}
                                  >
                                    <Col xs={12}>
                                      <span>{person.personFullName}</span>
                                    </Col>
                                  </Row>
                                </ListGroup.Item>
                              </div>
                            );
                          })}
                      </ListGroup>
                    </div>
                  </div>
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-start">
          <Button variant="primary" type="submit" className="px-5">
            ثبت
          </Button>
          <Button variant="outline-primary" type="button" onClick={handleClose}>
            بازگشت
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

export default ModalSelectName;
